import React from "react";
import { useImmer } from "use-immer";

import { IgTypography } from "@intelligems/ig-theme";
import { PersonalizationTestType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";
import { StartFromScratchCards } from "@src/features/offers/components/StartFromScratchCards";
import { SharedTableHeader } from "@src/features/sharedExperience/components/SharedTableHeader";
import { SiteContentTable } from "@src/features/siteContent/components/SiteContentTable";
import { useViewPage } from "@src/hooks/mixpanel";

export const SiteContentBody = () => {
  const [statusFilters, setStatusFilters] = useImmer<string[]>([]);
  const [typeFilters, setTypeFilters] = useImmer<PersonalizationTestType[]>([]);
  const [searchInput, setSearchInput] = useImmer<string>("");

  const personalizations = useGetExperiencesList({
    category: "personalization",
  });
  useViewPage("Site Content");
  return (
    <Grid container rowSpacing={8}>
      <StartFromScratchCards renderLocation={"overview"} />
      <SharedTableHeader
        title={"Site Content"}
        experienceData={personalizations}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        statusFilters={statusFilters}
        setStatusFilters={setStatusFilters}
        typeFilters={typeFilters}
        setTypeFilters={setTypeFilters}
        statusFilterListOptions={["Active", "Inactive", "Archived"]}
        typeFilterListOptions={
          [
            "Content Edits",
            "Theme",
            "Template",
            "Price",
            "Redirects",
          ] as PersonalizationTestType[]
        }
      />
      <SiteContentTable
        searchInput={searchInput}
        personalizationData={personalizations}
        statusFilters={statusFilters}
        typeFilters={typeFilters}
      />
    </Grid>
  );
};
